module.exports = __webpack_public_path__ + "img/1.cca25531.jpg";